import React from 'react';
import CardCompability from '../components/card_compability/Card_Compability';

const CompatibilidadWrapper = () => {
  return (
    <div className="App">
      <CardCompability />
    </div>
  );
};

export default CompatibilidadWrapper;
